import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import withPid from 'utils/withPid';
import Title from 'components/Title';
import { RouteItem } from 'stores/routes';
import './style.scss';

// @ts-ignore
@withPid('help')
class Help extends Component<
    RouteComponentProps & {
        route: RouteItem;
    }
> {
    _render() {
        return renderRoutes(this.props.route.routes);
    }

    render() {
        return (
            <div className="page-help">
                <Title title="Help" />
                {this._render()}
            </div>
        );
    }
}

export default Help;
